var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43582 6.89235C1.43582 4.32018 1.43582 3.03409 2.23489 2.23501C3.03397 1.43594 4.32006 1.43594 6.89223 1.43594C9.46438 1.43594 10.7505 1.43594 11.5496 2.23501C12.3486 3.03409 12.3486 4.32018 12.3486 6.89235C12.3486 9.46451 12.3486 10.7506 11.5496 11.5497C10.7505 12.3488 9.46438 12.3488 6.89223 12.3488C4.32006 12.3488 3.03397 12.3488 2.23489 11.5497C1.43582 10.7506 1.43582 9.46451 1.43582 6.89235Z",
    fill: "white",
    stroke: "#006838",
    strokeWidth: 0.861538
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59488 6.8921H9.18975M4.59488 6.8921C4.59488 6.48994 5.74032 5.73852 6.03078 5.45621M4.59488 6.8921C4.59488 7.29427 5.74032 8.0457 6.03078 8.328",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeLink);
export default __webpack_public_path__ + "static/media/EmployeeLink.e892d74d531f1c3eab3e816f5fce7753.svg";
export { ForwardRef as ReactComponent };